module.exports = __webpack_public_path__ + "img/tongren_yuan.1f84d3dc.jpg";